import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import common from './assets/js/common'
import API from '@/libs/homesite-api.js'
import { fetch } from '@/libs/http.js'
import TorinoSrcUtils from '@/libs/torinosrc-utils.js'
import VuePreview from 'vue-preview'
import Base64 from 'js-base64'
import VModal from 'vue-js-modal'

Vue.config.productionTip = false

// 定义全局变量
Vue.prototype.$api = API
Vue.prototype.$fetch = fetch
Vue.prototype.$common = common
Vue.prototype.$axios = axios
Vue.prototype.$TorinoSrcUtils = TorinoSrcUtils

Vue.use(VuePreview, {
  mainClass: 'pswp--minimal--dark',
  barsSize: {top: 0, bottom: 0},
  captionEl: false,
  fullscreenEl: false,
  shareEl: false,
  bgOpacity: 0.85,
  tapToClose: true,
  tapToToggleControls: false
})
Vue.use(VModal)
Vue.use(Base64)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js